import React from "react";
import get from "lodash/get";

import { getPrivateFileLinkRequest } from "../../api/requests";
import { Icon } from "antd";
import classes from "./FileLink.css";

class FileButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      privateFileLoading: null,
    };
  }

  openPrivateFileLink = async (e) => {
    e.preventDefault();
    this.setState({ privateFileLoading: true });

    const { data } = await getPrivateFileLinkRequest({
      url: this.props.url,
    });

    const link = document.createElement("a");
    link.href = get(data, "private_url");
    link.target = "_blank";
    link.click();

    this.setState({ privateFileLoading: false });
  };

  render() {
    const { privateFileLoading } = this.state;

    return (
      <a
        onClick={this.openPrivateFileLink}
        style={{ color: "#FAFAFA" }}
        className="menu-item"
      >
        {privateFileLoading && <Icon type="loading" className={classes.iconButton} />}
        {this.props.text}
      </a>
    );
  }
}

export default FileButton;



// WEBPACK FOOTER //
// ./src/components/FileLink/FileButton.js